import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function SmallPartyIcon({
  className,
  height,
  stroke = IconColors.DarkGrey,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      height={height ?? 14}
      viewBoxDimensions="0 0 14 14"
      width={width ?? 14}
    >
      <path
        d="M1.8450000000000002 4.305000000000001a2.2550000000000003 2.2550000000000003 0 1 0 4.510000000000001 0 2.2550000000000003 2.2550000000000003 0 1 0 -4.510000000000001 0"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.0"
      ></path>
      <path
        d="M0.41000000000000003 11.070000000000002a3.6900000000000004 3.6900000000000004 0 0 1 7.380000000000001 0"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.0"
      ></path>
      <path
        d="M7.845760000000001 5.535000000000001a1.8450000000000002 1.8450000000000002 0 1 0 3.6900000000000004 0 1.8450000000000002 1.8450000000000002 0 1 0 -3.6900000000000004 0"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.0"
      ></path>
      <path
        d="M8.644440000000001 8.237173333333335a3.0208800000000005 3.0208800000000005 0 0 1 4.0655600000000005 2.8328266666666675"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.0"
      ></path>
    </SimpleIcon>
  );
}
